<template>
    <nav>
      <vue-paginate
        v-model="page"
        container-class="pagination justify-content-center"
        :page-count="totalPage"
        prev-text="«"
        next-text="»"
        page-class="page-item"
        page-link-class="page-link"
        prev-link-class="page-link"
        next-link-class="page-link"
        :click-handler="callback"
      ></vue-paginate>
    </nav>
</template>
  
<script>
  export default {
    name: 'ContactPaginate',
    props: {
      totalPage: {
        type: Number,
        required: true
      },
      callback: {
        type: Function,
        required: true
      },
      currentPage: {
        type: Number,
        required: true,
        default: 1
      }
    },
    data() {
      return {
        page: 1,
      };
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(value) {
          this.page = value;
        }
      },
    },
    mounted() {
      this.page = this.currentPage;
    },
  };
  </script>
  
  <style scoped>
  >>> .pagination .page-link {
    color: #6c757d !important;
    background-color: #fff;
    border: 1px solid #dee2e6;
  }

  >>> .pagination .page-link:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  >>> .pagination .page-item.active .page-link {
    background-color: #e4e7ea !important;
    border-color: #e4e7ea !important;
    color: #3c3c3c !important;
  }

  >>> .pagination .page-link:hover {
    color: #3c3c3c !important;
    background-color: #e4e7ea;
  }
  </style>
  
